<template>
  <!-- !!! -->
  <!-- !!! -->
  <!-- !!! -->
  <!-- 若有改动，请仔细观察后端返回格式再来修改 -->
  <div>
    <div style="background-color: #ffffff;width: 100%;height: 70vh">
      <date-select style="visibility:hidden;"></date-select>
      <v-chart :options="option" :autoresize="true" v-if="CharShow"/>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/component/polar";
import "echarts/lib/chart/bar";
import DateSelect from "./components/DateSelect";
import { listSoftwareVersion } from '../../api/softwareversion'
import { GetSoftwareversion } from './components/GetValue'
export default {
  data() {
    return {
      //软件版本统计显示与隐藏
      CharShow:false,
      option: {
        backgroundColor: "#ffffff",
        color: ["rgba(0,133,245,0.7)"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#333333"
            }
          }
        },
        grid: {
          x: "0px",
          y: "20%",
          x2: "40px",
          y2: "0px",
          containLabel: true
        },
        // tooltip: {
        // trigger: 'item',
        // position: [20, 20],
        // formatter: `{b} : {c} <br/>${this.$t('lang.dashboard.form')} ：{d}`
        // },
        tooltip: {
        trigger: 'item',
        formatter: `${this.$t('lang.ReportManagement.Version')}:{b} <br/>
        ${this.$t('lang.ReportManagement.number')}:{c}`
        },
        legend: {
          data: [
            {
              name:this.$t('lang.ReportManagement.Version'),
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            }
          ],
          top: "10%",
          textStyle: {
            color: "#fff"
          }
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#7d838b"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: this.$t('lang.ReportManagement.number'),
            nameTextStyle: {
              color: "#7d838b"
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#7d838b"
              }
            },
            axisLine: {
              show: true
            },
            splitLine: {
              lineStyle: {
                color: "#7d838b"
              }
            }
          }
        ],
        series: [
          {
            name:this.$t('lang.ReportManagement.Version'),
            type: "bar",
            data: [],
            barWidth: "auto"
          }
        ]
      }
    };
  },
  mounted(){
    //进入页面获取软件版本图表
    listSoftwareVersion()
    .then(res=>{
      if(res.data.data){
        this.CharShow=true
        let data=GetSoftwareversion(res.data.data)
      this.option.xAxis[0].data=data.version
      this.option.series[0].data=data.counts
      }
    })
  },
  components: {
    DateSelect
  }
};
</script>
<style scoped>
.inputlist {
  width: 1.8rem;
  margin: 0.1rem;
}
.echarts {
  width: 100%;
  height: 90%;
}
</style>
